<!-- <all-projects *ngIf="oneTenant"></all-projects> -->

@if (isToSelect) {
  <div class="tenant-select-page">
    <div class="tenant-select-topbar">
      <h1 class="tenant-select-title">Mandanten</h1>
      <div class="suche">
        <i class="material-icons suche__icon">search</i>
        <input type="text" name="tenantSearch" class="suche__feld" [(ngModel)]="searchTerm" placeholder="Mandanten suchen">
        @if (searchTerm) {
          <button type="button" class="suche__leeren" aria-label="Suche leeren"
                  (click)="searchTerm = ''">
            <mat-icon>close</mat-icon>
          </button>
        }

      </div>
    </div>

    @if (isAdmin) {
      <p class="tenant-select-subtitle">{{this.translate.data['SELECTTENANT'] | translate}} oder als System Manager weiterarbeiten</p>
    }

    <div class="tenant-select-list">
      @if (!isLoadingResults) {
        @if (filteredTenants.length === 0) {
        <div class="hinweis hinweis__fehler" role="alert">
          <mat-icon>error_outline</mat-icon>
          <span>Kein Mandant passt zu Ihrer Suche.</span>
          <button type="button" class="hinweis__reset" (click)="searchTerm = ''">
            Suche zurücksetzen
          </button>
        </div>
        }
        @else {
          @for (tenant of filteredTenants; track tenant.id) {
            <div (click)="onRowClicked(tenant)" class="tenant-row">
              <div class="tenant-avatar" [class.tenant-avatar-sm]="tenant.id == emptyProjId">
                <!-- @if (tenant.image) {
                  <img [src]="'data:image/jpeg;base64,' + tenant.image" class="tenant-avatar-img">
                }
                @if (!tenant.image) { -->
                  {{ getInitials(tenant.displayName) }}
                <!-- } -->
              </div>
              <div class="tenant-details">
                <div class="tenant-name">{{ tenant.displayName }}</div>
              </div>
              <i class="material-icons tenant-chevron">chevron_right</i>
            </div>
          }
        }
      }
    </div>
  </div>
}
